export default "// Get your new account on NEAR testnet.\n// Replace the placeholder it with your id.\nYOUR_ID_HERE.testnet";